// extracted by mini-css-extract-plugin
export default {"circle":"src-signer-app-parts-loader-dot-loader-module__circle--3yFyS","fullPageLoader":"src-signer-app-parts-loader-dot-loader-module__fullPageLoader--17R3L"};